import React from "react";
import LoadingSpinner from 'core/widgets/loadingSpinnerWidget';
import "../../../../scss/reports.scss";
import { BaseError } from "core/utils/baseError";
import Error from "core/widgets/error";


type DashboardWidgetProps = {
    data: string | undefined;
    isLoading: boolean;
    isError: boolean;
    error: BaseError | null;
}


const QuickSightDashboardWidget: React.FC<DashboardWidgetProps> = ({ isError, isLoading, data, error }) => {

    if (isError && error) {
        return <Error error={error} />
    }

    if (isLoading) return <LoadingSpinner />

    return <iframe className="quicksight-iframe" src={data} />
};

export default QuickSightDashboardWidget;
